import { render, staticRenderFns } from "./share-space.vue?vue&type=template&id=3de7a285&scoped=true"
import script from "./share-space.vue?vue&type=script&lang=js"
export * from "./share-space.vue?vue&type=script&lang=js"
import style0 from "./share-space.vue?vue&type=style&index=0&id=3de7a285&prod&scoped=true&lang=css"
import style1 from "./share-space.vue?vue&type=style&index=1&id=3de7a285&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de7a285",
  null
  
)

export default component.exports